import { Config } from '@adornis/config/config.js';

const parseBoolean = (value: string): boolean => ['1', 'true', 'yes', 'on'].includes(value.trim().toLowerCase());

export const config = new Config('zwickroell', {
  TWILIO_ACCOUNT_SID: {
    env: true,
    name: 'TWILIO_ACCOUNT_SID',
    required: true,
    client: false,
  },
  TWILIO_AUTH_TOKEN: {
    env: true,
    name: 'TWILIO_AUTH_TOKEN',
    required: true,
    client: false,
  },
  TWILIO_REDIRECT_NUMBER: {
    env: true,
    name: 'TWILIO_REDIRECT_NUMBER',
    required: true,
    client: false,
  },
  TWILIO_NUMBER: {
    env: true,
    name: 'TWILIO_NUMBER',
    required: true,
    client: false,
  },
  AZURE_OPENAI_BASE_URL: {
    env: true,
    name: 'AZURE_OPENAI_BASE_URL',
    required: true,
    client: false,
  },
  AZURE_OPENAI_API_KEY: {
    env: true,
    name: 'AZURE_OPENAI_API_KEY',
    required: true,
    client: false,
  },
  AZURE_EMBEDDING_BASE_URL: {
    env: true,
    name: 'AZURE_EMBEDDING_BASE_URL',
    required: true,
    client: false,
  },
  AZURE_EMBEDDING_API_KEY: {
    env: true,
    name: 'AZURE_EMBEDDING_API_KEY',
    required: true,
    client: false,
  },
  AZURE_MODEL: {
    env: true,
    name: 'AZURE_MODEL',
    required: true,
    client: false,
  },
  MCP_SERVER_URL: {
    env: true,
    name: 'MCP_SERVER_URL',
    required: false,
    defaultVal: 'http://zue-s-388:8080',
    client: false,
  },
  MCP_DEBUG_USE_MOCKS: {
    env: true,
    name: 'MCP_DEBUG_USE_MOCKS',
    required: false,
    defaultVal: false,
    parse: parseBoolean,
    client: false,
  },
  MCP_DEBUG_FALLBACK_TO_MOCKS: {
    env: true,
    name: 'MCP_DEBUG_FALLBACK_TO_MOCKS',
    required: false,
    defaultVal: true,
    parse: parseBoolean,
    client: false,
  },
  // 🔄 2026-05-20 dev fallback — schema-declared so @adornis/config exports it into
  // process.env. The OpenRouterHandler reads process.env.OPENROUTER_API_KEY directly.
  // Optional: only set in dev .env when Azure-Mistral is unavailable.
  OPENROUTER_API_KEY: {
    env: true,
    name: 'OPENROUTER_API_KEY',
    required: false,
    defaultVal: '',
    client: false,
  },
  // 🔀 LLM provider selector — 'azure' (default, GDPR/EU prod) or 'openrouter' (dev fallback).
  //   Prod ignores the repo .env (config from production-compose), so prod always defaults to azure.
  LLM_PROVIDER: {
    env: true,
    name: 'LLM_PROVIDER',
    required: false,
    defaultVal: 'azure',
    client: false,
  },
});
